import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

const Button = ({
  label,
  type = 'button',
  onClick,
  disabled = false, 
  fullWidth,
  size = 'large',
  variant = 'primary',
}) => {
  return (
    <button 
      type={type}
      className={`${styles.button}
                  ${disabled ? styles.disabled : ''}
                  ${fullWidth ? styles.fullWidth : ''} 
                  ${size && styles[size] ? styles[size] : ''}
                  ${variant && styles[variant] ? styles[variant] : ''}`} 
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.any.isRequired,
  type: PropTypes.oneOf(['button', 'submit']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'secondary-light', 'black', 'white', 'cancel', 'grey', 'primary-light']),
}

export default Button;